import { Base64Downloader } from './Base64Downloader';
import { ToBlob } from './ToBlob';
export const Base64toNewTab = (base64Pdf) => {
  try {
    const blob = ToBlob(base64Pdf);
    if (
      window.navigator &&
      window.navigator.msSaveOrOpenBlob
    ) {
      window.navigator.msSaveOrOpenBlob(
        blob,
        'pdfBase64.pdf'
      );
    } else {
      const blobUrl = URL.createObjectURL(blob);
      const popupWindow = window.open(
        blobUrl,
        '_blank',
        'noopener,noreferrer'
      );
      if (popupWindow) {
        popupWindow.opener = window;
        popupWindow.focus();
      } else {
        // Popup was blocked, show an error message or prompt the user to allow popups
        console.error(
          'Popup was blocked by the browser. Please allow popups to view the PDF.'
        );
      }
    }
  } catch (err) {
    Base64Downloader(base64Pdf, `${uuidV4()}`);
  }
};
